import { useEffect, useCallback } from 'react';

function resetVars(stage) {
  stage.style.setProperty('--mx', '50%');
  stage.style.setProperty('--my', '50%');
  stage.style.setProperty('--px', '0px');
  stage.style.setProperty('--py', '0px');
  stage.style.setProperty('--rx', '0deg');
  stage.style.setProperty('--ry', '0deg');
}

function updateVars(stage, e) {
  const r = stage.getBoundingClientRect();
  const x = (e.clientX - r.left) / r.width;
  const y = (e.clientY - r.top) / r.height;
  const dx = x - 0.5;
  const dy = y - 0.5;
  stage.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
  stage.style.setProperty('--my', (y * 100).toFixed(1) + '%');
  stage.style.setProperty('--px', (dx * -45).toFixed(1) + 'px');
  stage.style.setProperty('--py', (dy * -35).toFixed(1) + 'px');
  stage.style.setProperty('--rx', (dx * 18).toFixed(2) + 'deg');
  stage.style.setProperty('--ry', (dy * -14).toFixed(2) + 'deg');
}

export function useStagePointer(stageRef) {
  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const onMove = (e) => updateVars(stage, e);
    const onLeave = () => resetVars(stage);

    stage.addEventListener('mousemove', onMove);
    stage.addEventListener('mouseleave', onLeave);

    return () => {
      stage.removeEventListener('mousemove', onMove);
      stage.removeEventListener('mouseleave', onLeave);
    };
  }, [stageRef]);

  const replayIntro = useCallback(() => {
    const stage = stageRef.current;
    if (!stage) return;
    const el = stage.querySelector('.entrance');
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
  }, [stageRef]);

  return { replayIntro };
}
